import { RawButton } from '@/components/Button'
import { Dropdown, DropdownItem, DropdownTitle } from '@/components/Dropdown'
import { Icon } from '@/components/Icon'
import styles from './InventoryViewer.module.css'

export interface InventoryViewerOption {
  key: string
  title: string
  valueTitle: string
  isActive: boolean
  onSelect: () => void
}

export interface InventoryViewerProps {
  title: string
  selectedTitle?: string
  options: InventoryViewerOption[]
}

export function InventoryViewer({
  title,
  selectedTitle,
  options,
}: InventoryViewerProps) {
  return (
    <Dropdown
      autoDismiss
      position="bottom-start"
      button={
        <RawButton className={styles.root}>
          {title} {selectedTitle}
          <Icon auto name="dropdown" />
        </RawButton>
      }
      testId="inventory-viewer-dropdown"
    >
      <DropdownTitle>View</DropdownTitle>
      {options.map((option) => (
        <FilterOptionItem key={option.key} option={option} />
      ))}
    </Dropdown>
  )
}

interface FilterOptionItemProps {
  option: InventoryViewerOption
}

function FilterOptionItem({ option }: FilterOptionItemProps) {
  return (
    <DropdownItem
      onPress={option.onSelect}
      checkmark={option.isActive}
      active={option.isActive}
      buttonTestId={`inventory-item-type-filter-${option.valueTitle}`}
    >
      <div className={styles.filterText}>{option.title} </div>
    </DropdownItem>
  )
}
